export default "__VITE_ASSET__DnW1UZJa__"